import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import { PropType } from 'vue'

export interface TableColumn {
  label: string
  type: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableWithStickyHeader',
  props: {
  columns: {
    type: Array as PropType<TableColumn[]>,
    default: () => [],
  },

  data: {
    type: Array as PropType<string[][]>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, i) => {
          return (_openBlock(), _createElementBlock("th", {
            key: `th-${i}`,
            class: _normalizeClass(`col-type-${column.type ?? 'any'}`)
          }, _toDisplayString(column.label), 3))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (row, i) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: `tr-${i}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, j) => {
            return (_openBlock(), _createElementBlock("td", {
              key: `td-${i}-${j}`,
              class: _normalizeClass(`col-type-${__props.columns[j].type ?? 'any'}`)
            }, _toDisplayString(cell), 3))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})